import {Component,EventEmitter, Inject, Output, OnDestroy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ConfirmationDialogModel} from './confirmation-dialog.model';
import {SubsequentDeliveriesUpdate} from '../../../core/models/subsequent-deliveries/subsequent.deliveries.update';
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {SubsequentDeliveriesService} from '../../../core/services/subsequent-deliveries.service';

@Component({
    selector: 'confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})

export class ConfirmationDialogComponent implements OnDestroy{
    title: string;
    message: string;
    delivery: any;
    private ngUnsubscribe$ = new Subject<void>();
    @Output() sendDelete = new EventEmitter();

    constructor(
        public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogModel,
        public subsequentDeliveriesService: SubsequentDeliveriesService,
    ) {
        this.title = data.title;
        this.message = data.message;
        this.delivery = data.delivery;
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onYesClick(): void {
        if(this.delivery !== undefined){
        this.subsequentDeliveriesService.deleteDelivery(this.delivery).pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(s => {
            if(s){
               this.sendDelete.emit(1);
            }else{
               this.sendDelete.emit(0);
            }
                this.dialogRef.close();
                return true;
        });
        }
    }

    /**
     * Unsubscribe from all subscriptions.
     */
    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }
}
